import { render, staticRenderFns } from "./baikexiangqing.vue?vue&type=template&id=6548d6ea&scoped=true"
import script from "./baikexiangqing.vue?vue&type=script&lang=js"
export * from "./baikexiangqing.vue?vue&type=script&lang=js"
import style0 from "./baikexiangqing.vue?vue&type=style&index=0&id=6548d6ea&prod&lang=less&scoped=true"
import style1 from "./baikexiangqing.vue?vue&type=style&index=1&id=6548d6ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548d6ea",
  null
  
)

export default component.exports